import { apiUrl } from "../apiendpoint";
let cachedPermissions: string[] | null = null;
let cachedUser: any | null = null;


// const API_URL = "http://localhost:8000/api"; // move to env in real prod
//const API_URL = "https://test.ssdneducation.com/api"; // move to env in real prod
// const API_URL = "https://test.ssdneducation.com/api"; // move to env in real prod

// 🔁 React Admin → RBAC action mapping
const ACTION_MAP: Record<string, string> = {
  list: "read",
  show: "read",
  edit: "edit",
  create: "create",
  delete: "delete",
};

// 🔐 Permission evaluation (single source of truth)
const hasAccess = (
  permissions: string[],
  resource: string,
  action: string
): boolean => {
  // SUPER ADMIN
  if (permissions.includes("*") || permissions.includes("*.*")) return true;

  const r = resource.toLowerCase();
  const a = action.toLowerCase();

  return (
    permissions.includes(`${r}.${a}`) || // users.read
    permissions.includes(`${r}.*`) ||     // users.*
    permissions.includes(`*.${a}`)         // *.read
  );
};

const authProvider = {
  login: async ({ token, email }) => {
    localStorage.setItem("access_token", token);
    localStorage.setItem("user_email", email);
    return Promise.resolve();
  },

  logout: () => {
    cachedPermissions = null;
    cachedUser = null;
    localStorage.clear();
    return Promise.resolve();
  },

  checkAuth: () => {
    return localStorage.getItem("access_token")
      ? Promise.resolve()
      : Promise.reject();
  },

  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      cachedPermissions = null;
      cachedUser = null;
      localStorage.clear();
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getIdentity: async () => {
    if (cachedUser) {
      return {
        id: cachedUser.email,
        fullName: cachedUser.email,
      };
    }

    const email = localStorage.getItem("user_email");
    return Promise.resolve({
      id: email,
      fullName: email,
    });
  },

  getPermissions: async () => {
    if (cachedPermissions) return cachedPermissions;

    const token = localStorage.getItem("access_token");
    if (!token) return [];

    const response = await fetch(`${apiUrl}users/me`,  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) return [];

    const data = await response.json();
    cachedUser = data;

    // normalize once
    cachedPermissions = (data.permissions || []).map((p: String) =>
      p.toLowerCase()
  );
  console.log("Fetched permissions:", cachedPermissions)  

    return cachedPermissions;
  },

  canAccess: async ({ action, resource }) => {
  console.log("resource:", resource);
  console.log("action:", action);

  let normalizedResource = resource.toLowerCase();

  // ✅ Explicit mappings FIRST (most reliable)
  if (normalizedResource === "form-types"|| normalizedResource === "feedback-type-summary"|| normalizedResource === "feedback-submissions") {
    normalizedResource = "forms";
  }

  if (normalizedResource === "assign-certificate"){
    normalizedResource= "certificate"
    console.log("Mapped assign-certificate to certificate");
  }

  if (normalizedResource === "courses" ||normalizedResource === "user-guide-assignments" ){
    normalizedResource= "user-guides"
  }
  if (normalizedResource === "categories" ||normalizedResource === "questions" ){
    normalizedResource= "assessments"
  }

  // // ✅ Generic dash handling AFTER
  // else if (normalizedResource.includes("-")) {
  //   normalizedResource = normalizedResource.split("-")[0] + "s";
  // }

  const permissions =
    cachedPermissions ?? (await authProvider.getPermissions());

  if (!permissions?.length) return false;

  const mappedAction = ACTION_MAP[action];
  if (!mappedAction) return false;

  return hasAccess(permissions, normalizedResource, mappedAction);
}
};

export default authProvider;
